export default __webpack_public_path__ + "static/media/pnsv_stand_Tiusa.96dca30e.png";